module.exports = __webpack_public_path__ + "img/ARC.3de83920.png";